import { render, staticRenderFns } from "./SendWhatsapp.vue?vue&type=template&id=3c6fb286&scoped=true&"
import script from "./SendWhatsapp.vue?vue&type=script&lang=js&"
export * from "./SendWhatsapp.vue?vue&type=script&lang=js&"
import style0 from "./SendWhatsapp.vue?vue&type=style&index=0&id=3c6fb286&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6fb286",
  null
  
)

export default component.exports